import type { ModelProgressState } from "../types";
import type { Language } from "./languages";
import { ui } from "./localization";

export function modelProgressLabel(progress: ModelProgressState | undefined, language: Language): string | undefined {
  if (!progress) return;
  if (progress.phase === "recovering") return ui(language, "Model output paused. Automatically retrying with saved progress…");
  const quiet = Math.max(0, Math.floor(progress.quietSeconds ?? 0));
  if (quiet >= 15) return ui(language, "No new model output for {0}s. Checking the connection…", quiet);
  if (progress.phase === "preparing_tool") return ui(language, "Preparing a tool call…");
  if (progress.phase === "waiting") return ui(language, "Waiting for the model…");
}
